import React from 'react';
import { Button, ButtonProps } from '../Button';
import { Theme, useTheme } from '@material-ui/core/styles';

interface Props extends ButtonProps {
  variant?: 'text' | 'solid';
}

export const getStyle = (
  theme: Theme,
  variant?: 'text' | 'solid',
): {
  backgroundColor?: string;
  color: string;
  fontWeight: number;
} => {
  let style;
  switch (variant) {
    case 'solid':
      style = { backgroundColor: theme.palette.error.main, color: '#ffffff', fontWeight: 700 };
      break;
    default:
      style = { color: theme.palette.error.main, fontWeight: 700 };
      break;
  }
  return style;
};

export const CancelButton = ({ className, variant, ...rest }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Button
      {...rest}
      className={`cancelButton ${className}`}
      type="button"
      variant="text"
      style={getStyle(theme, variant)}
    />
  );
};
